import { Dispatch } from "@reduxjs/toolkit";
import { TabType } from "../helpers/types";
import { changeTabsPositions } from "../api/tabs.api";

export const setTabsPositions = (dispatch: Dispatch, newTabs: TabType[]) => {
  changeTabsPositions(dispatch, newTabs);
};
